<template>
  <div class="product pb-6" :class="{'isNewProduct':product.isNew || product.isTop}">
    <div @click="focusProduct" class="image">
      <div v-if="product.isNew" class="new__balloon  flex float-right justify-center text-center"><p
        class="transform -rotate-45">New</p></div>
      <div v-if="product.isTop" class="new__balloon flex float-right justify-center text-center"><p
        class="transform -rotate-45">Top</p></div>
      <img v-if="product.thumbnail" :src="product.thumbnail" alt="thumbnail">
      <img v-else class="classen__rounded border-classen__secondary border"
           src="../../../assets/media/NoImage.png" alt="no image">
    </div>
    <div v-if="displayDelete" @click="$emit('delete')" class="delete relative"><i
      class="fa fa-trash"></i></div>
    <c-selection v-if="displayQuick" class="w-8/10 selection poi"
                 :product="product"
                 :selectedSelection="selectedSelection"
                 @changed-selection="changeSelected"
                 @addSelectionToProduct="addToSelection"
                 @removeSelectionFromProduct="removeSelection">

    </c-selection>

    <div @click="focusProduct" :class="{'raise':displayQuick, 'raiseDelete':displayDelete}"
         class="mb-1 grid grid-cols-10">
      <p class="font-bold name col-span-8 text-left">{{ product.name }} </p>
      <p class="col-start-9 justify-items-end col-span-2">
        {{ product.articleNumber ? product.articleNumber : product.externalId }}</p>
    </div>

    <div @click="focusProduct">
      <p class="text-sm text-left ">{{ product.collection }}</p>
      <p class="text-sm text-left">{{ product.category }}</p>
      <p class="text-sm text-left">{{ product.range }}</p>
    </div>
  </div>
</template>

<script>
import SelectionDropdown from "../SelectionDropdown";
import EventBus from "../../../services/EventBus";

export default {
  name: "ProductView",

  props: {
    product: {required: true, type: Object},
    displayQuick: {required: true, type: Boolean, default: true},
    selectedSelection: {
      required: false,
      type: Object,
      default: function () {
        return {id: -1, name: "Set default selection"}
      }
    },
    displayDelete: {required: true, type: Boolean, default: false},
  },

  components: {
    'c-selection': SelectionDropdown
  },

  data() {
    return {
      productSelection: this.selectedSelection
    }
  },

  computed: {},

  watch: {
    selectedSelection() {
      this.productSelection = this.selectedSelection
    }
  },

  methods: {
    changeSelected(selection) {
      this.productSelection = selection;
      EventBus.fire('changed-active-selection', selection, true)
    },

    focusProduct(e) {
      EventBus.fire('set-active_product', this.product, this.productSelection)
    },

    removeSelection(selection) {
      this.$dashboardStore.dispatch('removeProductFromSelection', {
        productId: this.product.id,
        selectionId: selection.id
      }).then(() => {
        this.product.selections = this.product.selections.filter((selectionItem) => {
          return selectionItem.id !== selection.id
        });
      });
    },

    addToSelection(selection = null) {
      if (this.selectedSelection.id === -1 && selection === null) {
        return
      }

      if (selection === null) {
        this.$dashboardStore.dispatch('addProductToSelection', {
          productId: this.product.id,
          selectionId: this.selectedSelection.id
        }).then(() => {
          this.product.selections.push(this.selectedSelection)
        });
      } else {
        this.$dashboardStore.dispatch('addProductToSelection', {
          productId: this.product.id,
          selectionId: selection.id
        }).then(() => {
          this.product.selections.push(selection)
        });
      }
    },
  },
}
</script>

<style scoped>
.product {
  width: 300px;
}

.product:hover {
  cursor: pointer;
}

.isNoNewProduct {
  margin-bottom: -40px;
}

.isNewProduct {
  margin-top: -40px;
}

img {
  width: 300px;
  height: 195px;
  object-fit: none;
  border-radius: 35px 0 35px 0;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* number of lines to show */
}

.selection {
  position: relative;
  top: -55px;
}

.raise {
  margin-top: -42px;
}

.raiseDelete {
  margin-top: -32px;
}

.delete {
  transform: translate(5px, -35px);
  height: 30px;
  width: 30px;
  color: white;
  border-radius: 20px;
  line-height: 30px;
  text-align: center;
  background-color: var(--primary)
}
</style>
